$(document).ready(function(){
	
	var weatherBtn = $('.btn--meteo');
	
	// weatherBtn.on('click', function(e){
		// e.preventDefault();

	  // // Set vars
	  // var city = 'Grevenmacher,LU';
	  // var units = 'metric';
	  // var cnt = '3';
	  // var appid = '08ab2cc9066cda84f867361619691ceb';
	  // var mode = 'json';
	  // var lang = $('html').attr('lang');

	  // // Ajax request
	  // $.ajax({
	  //   url: 'http://api.openweathermap.org/data/2.5/forecast/daily?q='+city+'&units='+units+'&cnt='+cnt+'&appid='+appid+'&mode='+mode+'&lang='+lang,
	  //   success: function(response){
	  //     console.log('success');
	  //     console.log(response);
	  //     $('.weather').fadeIn();
	  //     // $('body').addClass('weather--open');
	  //     // $.each(response, function(key, value){
	  //     // 	console.log(key+' - '+ value);
	  //     // });
	  //   },
	  //   error: function(response){
	  //     console.log('error');
	  //     console.log(response);
	  //   }
	  // });


	  // ------------------------------------------------------------

	 //  var data = [];
		// // data[csrfTokenName] = 'csrfTokenValue';

	 //  $.ajax({
	 //    type: 'POST',
	 //    url: '/',
	 //    data: data,
	 //    dataType: 'json',
	 //    success: function(response, statut){
	 //      console.log('SUCCESS');
	 //      console.log(response);
	 //      console.log(statut);
	      
	 //    },
	 //    error: function(response, statut, error){
	 //      console.log('ERROR');
	 //      console.log(response);
	 //      console.log(statut);
	 //      console.log(error);
	      
	 //    }
	 //  });
	     

	// });

	$('.btn--meteo').on('click', function(e){
		e.preventDefault();
		$('.weather').fadeIn();
	});

	$('.weather').on('click', function(){
		$('.weather').fadeOut();
	});

	// $('.weather .close__btn').on('click', function(){
	// 	$('.weather').fadeOut();
	// });

});